module.exports = __webpack_public_path__ + "static/media/profPic.b33ca93a.png";